import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./api.request";

const BED_SUB_CATEGORY_PATH = "/bed-sub-category/v1";

export const getBedSubCategoryApi = async (params, options = {}) => await getRequest(BED_SUB_CATEGORY_PATH, params, options);

export const getBedSubCategoryByIdApi = async (id) =>
  await getRequest(`${BED_SUB_CATEGORY_PATH}/${id}`);

export const addBedSubCategoryApi = async (body) =>
  await postRequest(BED_SUB_CATEGORY_PATH, body);

export const updateBedSubCategoryApi = async (body) =>
  await putRequest(`${BED_SUB_CATEGORY_PATH}/${body?._id}`, body);

export const deleteBedSubCategoryByIdApi = async (id) =>
  await deleteRequest(`${BED_SUB_CATEGORY_PATH}/${id}`);
